<h2 mat-dialog-title>Dismiss result</h2>

<mat-dialog-content>
    <p class="target">
        <b>{{ data.patientLabel }}</b>
        <span class="specimen" *ngIf="data.specimenNumber"> &middot; specimen {{ data.specimenNumber }}</span>
    </p>
    <p class="hint">A reason is required. It is stored with the result so the decision can be audited.</p>

    <mat-form-field appearance="outline" class="full-width">
        <mat-label>Reason</mat-label>
        <mat-select [(ngModel)]="selectedPreset">
            <mat-option *ngFor="let preset of presetReasons" [value]="preset">{{ preset }}</mat-option>
            <mat-option value="other">Other (type below)</mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width" *ngIf="selectedPreset === 'other' || !selectedPreset">
        <mat-label>Reason detail</mat-label>
        <textarea matInput rows="3" [(ngModel)]="otherReason" placeholder="Why is this result being dismissed?"></textarea>
    </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button type="button" mat-button (click)="cancel()">Cancel</button>
    <button type="button" mat-raised-button color="warn" [disabled]="!canConfirm" (click)="confirm()">Dismiss</button>
</mat-dialog-actions>
